import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import styles from './BestItem.module.scss'
import cl from 'classnames'
import { BestItemProps, BestItemRef } from './BestItem.types'
import { BestItemBody } from './BestItemBody'

const BestItemComponent = (props: BestItemProps, ref: BestItemRef) => {
  const {
    className,
    style,
    item,
    initialShowState,
    positionFixed
  } = props

  const [show, showComponent] = useState(Boolean(initialShowState))
  const [positionedLeft, setPositionLeft] = useState(false)
  const [fixedPosition, setFixedPosition] = useState<{ top: number, left: number }>(undefined)
  const container = useRef<HTMLDivElement>(null)

  const refreshFixedPosition = (ev: MouseEvent) => {
    if (fixedPosition) return
    setFixedPosition({
      top: ev.clientY + 20,
      left: ev.clientX + 20
    })
    document.removeEventListener('mousemove', refreshFixedPosition, false)
  }

  useEffect(() => {
    if (!positionFixed || fixedPosition) return
    document.addEventListener('mousemove', refreshFixedPosition, false)
    return () => document.removeEventListener('mousemove', refreshFixedPosition, false)
    // eslint-disable-next-line
  }, [container, positionFixed, fixedPosition])

  useImperativeHandle(ref, () => ({
    showComponent,
    setPositionLeft
  }))

  if (!item || !item.productId || !show) return null

  return (
    <div
      ref={container}
      className={cl(styles.container, className)}
      style={{
        left: positionedLeft ? 'unset' : '100%',
        right: positionedLeft ? '100%' : 'unset',
        ...fixedPosition,
        ...style,
        position: style?.position || (positionFixed ? 'fixed' : undefined)
      }}
    >
      <BestItemBody item={item} />
    </div>
  )
}

const BestItem = forwardRef(BestItemComponent)
export { BestItem }
